/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]:hover{color:#007072;text-decoration:none}a.phone[_ngcontent-%COMP%]{color:#f5f5f5;text-decoration:underline}"];
export { styles as styles };
